import React from 'react';
import { ProductSummary } from '../models/types';
import { StatusBadge } from './StatusBadge';

interface Props {
  product: ProductSummary;
}

export const ProductCard = ({ product }: Props): JSX.Element => (
  <div className="card">
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <h3>{product.name}</h3>
      <StatusBadge status={product.status} />
    </div>
    <p className="muted">Only visible because this tenant is entitled.</p>
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '8px' }}>
      {product.features.map((feature) => (
        <span key={feature} className="badge-subtle">
          {feature}
        </span>
      ))}
    </div>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '8px',
        marginTop: '12px'
      }}
    >
      <a href={product.deepLinks.launch}>Launch app</a>
      <a href={product.deepLinks.documentation}>Documentation</a>
      <a href={product.deepLinks.adminGuide}>Admin guide</a>
      <a href={product.deepLinks.support}>Support</a>
    </div>
  </div>
);
